import React, { useContext } from 'react';
import { ModalsDispatchContext } from '@components/common/modal/ModalContext';

type ModalPropsType = {
  title?: string | React.ReactElement;
  content?: string | React.ReactElement;
  submitLabel?: string;
  cancelLabel?: string;
  onClose?: Function;
  onClickSubmit?: Function;
  onClickCancel?: Function;
  onClickClose?: Function;
  children?: React.ReactNode;
  needCloseButton?: boolean;
  Component?: (props: any) => React.ReactElement;
};

export default function useModals() {
  const { open, close } = useContext(ModalsDispatchContext);

  const openModal = (
    Component: (props: any) => React.ReactNode,
    props: ModalPropsType | { [T in string]: any },
  ) => {
    open(Component, props);
  };

  const closeModal = (Component: (props: any) => React.ReactElement) => {
    close(Component);
  };

  return {
    openModal,
    closeModal,
  };
}
